export const PageTitle = (props: { title: string, hide?: boolean }) => {
    document.title = props.title + " | Corny Bakers Shop";

    if (props.hide) {
        return null;
    }
    return (<Title title={props.title}/>);
}

function Title(props: { title: string }) {
    return <h1 className={'placehold mb-3'} aria-hidden={'true'}>{props.title}</h1>;
}
